import { Dispatch, SetStateAction, useEffect, useState } from "react"
import ModalPortal from "../../Assets/ModalPortal/ModalPortal"
import clsx from "clsx"
import Button from "../../Assets/Button/Button"
import { useScrollBlock } from "../../../hooks/useScrollBlock"
import QRScan from "../../QRScan/QRScan"
import QRScan3 from "../../QRScan/QRScan3"
import { useTranslation } from "react-i18next"
import styles from "./QrScanModal.module.scss"
import {CameraDevice} from "html5-qrcode";
import {SELECTED_QR_CAMERA} from "../../../utils/constants";
import {getCookie} from "../../../utils/cookies";

interface Props {
  open: boolean
  setOpen: Dispatch<SetStateAction<boolean>>
  afterScaningFunc?: (val?: any) => void
  callbackError?: (err?: any) => void
}

const QrScanModal = ({ open, setOpen, afterScaningFunc, callbackError }: Props) => {
  const { t } = useTranslation("translation", { keyPrefix: `interface` })

  const [isQrActive, setQrActive] = useState<boolean>(false)
  const [isQrLoading, setQrLoading] = useState<boolean>(false)
  const [qrIsError, setqrIsError] = useState<boolean>(false)
  const [nowActiveCamera, setNowActiveCamera] = useState<number>(Number(getCookie(SELECTED_QR_CAMERA) || 1))
  const { allowScroll } = useScrollBlock()

  useEffect(() => {
    setTimeout(() => {
      setQrActive(true)
    }, 0)
  }, [])

  const checkSetOpen = (newOpenValue: any) => {
    if (isQrLoading) {
      setOpen(newOpenValue)
    }
  }

  return (
    <ModalPortal
      isOpen={open}
      setIsOpen={checkSetOpen}
      isCloseBtn={isQrLoading}
      header={!isQrLoading ? false : <h2 className={clsx("modal__title")}>{t("qr.scan")}</h2>}
      className={styles.modal}
    >
      {!qrIsError && (
        <p className={styles.description}>
          <span>{t("qr.pointCameraAtQr")}</span>
        </p>
      )}
      <div className={styles.qrWrap}>
        {/*{isQrActive && <QRScan afterScaningFunc={afterScaningFunc} callbackError={callbackError} />}*/}
        {isQrActive && <QRScan3 isQrLoading={isQrLoading} setQrLoading={setQrLoading} nowActiveCamera={nowActiveCamera} qrIsError={qrIsError} setQrIsError={setqrIsError} afterScaningFunc={afterScaningFunc} callbackError={callbackError} setOpen={checkSetOpen} />}
      </div>

      <footer className={styles.footer}>
        {!qrIsError && (
          <Button
            txt={t('changeQrCamera')}
            onClick={() => {
              setNowActiveCamera((prev) => {
                return prev+1
              })
            }}
            className={styles.btnBack}
          />
        )}
        <Button
          txt={t("back")}
          mode={"gray"}
          onClick={() => {
            allowScroll(true)
            checkSetOpen(false)
          }}
          className={styles.btnBack}
        />
      </footer>
    </ModalPortal>
  )
}

export default QrScanModal
